import { render } from "./InformacionEconomica.vue?vue&type=template&id=a32c08bc"
import script from "./InformacionEconomica.vue?vue&type=script&lang=js"
export * from "./InformacionEconomica.vue?vue&type=script&lang=js"

import "./InformacionEconomica.vue?vue&type=style&index=0&id=a32c08bc&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__